import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";
import { buildHead, SITE_URL } from "@/components/SEO";
import { buildFaqJsonLd } from "@/components/FAQSection";
import { FAQS } from "@/data/faqs";

export const Route = createFileRoute("/virtual-try-on")({
  head: () =>
    buildHead({
      path: "/virtual-try-on",
      jsonLd: buildFaqJsonLd(FAQS["/virtual-try-on"].items),
      breadcrumbs: [
        { name: "Home", url: SITE_URL },
        { name: "Virtual Try-On", url: `${SITE_URL}/virtual-try-on` },
      ],
    }),
  component: lazyRouteComponent(() => import("@/pages/VirtualTryOn")),
});
